import React, { useState, useEffect } from "react";
import { Table, Spinner, Form } from "react-bootstrap";
import axios from "axios";

const BASE_URL = "https://dailydish.in/api";

const todayISO = () => new Date().toISOString().slice(0, 10);

const outputUnit = (outputType) => {
  if (outputType === "weight") return "kg";
  if (outputType === "pieces") return "pcs";
  if (outputType === "pack") return "pk";
  return "";
};

const KarleProduction = () => {
  const [date, setDate] = useState(todayISO());
  const [cookableItems, setCookableItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getCookableItems = async (d) => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        `${BASE_URL}/karle/production/today-cookable-items`,
        {
          params: { date: d },
        },
      );
      if (res.data.success) setCookableItems(res.data.data.cookableItems);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getCookableItems(date);
  }, [date]);

  return (
    <div className="p-2">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">Production</h3>
        <Form.Control
          type="date"
          style={{ width: 200 }}
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
      </div>

      {isLoading ? (
        <div className="text-center my-5">
          <Spinner animation="border" variant="oranged" />
        </div>
      ) : (
        <Table responsive bordered>
          <thead>
            <tr>
              <th>Item</th>
              <th>Quantity You'll Receive</th>
            </tr>
          </thead>
          <tbody>
            {cookableItems.map((item) => (
              <tr key={item.cookableItemId}>
                <td>{item.name}</td>
                <td>
                  {item.totalQty} {outputUnit(item.outputType)}
                </td>
              </tr>
            ))}
            {cookableItems.length === 0 && (
              <tr>
                <td colSpan={2}>No orders placed for this date yet</td>
              </tr>
            )}
          </tbody>
        </Table>
      )}
    </div>
  );
};

export default KarleProduction;
